import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from 'app/shared/models/User';
import { SharedService } from 'app/shared/services/shared.service';
import { CompanyAuditService } from 'app/company-audit/services/company-audit.service';
import { LendersService } from 'app/lenders/services/lenders.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserAuditService } from 'app/user-audit/services/user-audit.service';
import { MyAuditListModel } from 'app/user-audit/models/my-audit-list.model';
import { CompanyUserModel } from 'app/shared/models/company-user.model';
import { ICompanyAuditDetailsModel } from 'app/company-audit/models/company-audit-details.model';
import { CompanyAuditModuleViewModel } from 'app/company-audit/models/company-audit-module-view.model';
import { Result } from 'app/core/models/result';
import { ReportCompanyAuditModuleModel } from 'app/company-audit/models/report-company-audit-module';
import { ReportSelectorCompanies } from '../../../company-audit/models/report-selector-companies.model';
import { ReportSelectorUsers } from '../../../company-audit/models/report-selector-users.model';
import { ReportSelectorModules } from '../../../company-audit/models/report-selector-modules.model';
import { SummaryRating } from '../../../shared/models/summaryRating.model';
import * as moment from 'moment';
import { LendersModel } from '../../../lenders/models/lenders.model';
import { CompanyListModel } from '../../../company/models/company-list.model';
import { CompanyService } from '../../../company/services/company.service';
import { CompanyDetailsModel } from '../../../company/models/company-details-model';
import { CompanyUserListModel } from '../../../company/models/company-user-list-model';
import { AuditModuleQueryModel } from '../../models/audit-module-query.model';

@Component({
    selector: 'app-lenders-user-audit-modules',
    templateUrl: './lenders-user-audit-modules.component.html',
    styleUrls: ['./lenders-user-audit-modules.component.css']
})
export class LendersUserAuditModulesComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    userUrl: Router;
    user: User;
    lender: LendersModel;
    companiesList: CompanyListModel[];
    companyId: string;
    userId: string;
    company: CompanyDetailsModel;
    users: CompanyUserListModel[];
    selectedModules: CompanyAuditModuleViewModel[];
    auditModuleQueryModel: AuditModuleQueryModel;


    constructor(
        private userAuditService: UserAuditService,
        private activatedRoute: ActivatedRoute,
        private sharedService: SharedService,
        private lendersService: LendersService,
        private companyService: CompanyService,
        private companyAuditService: CompanyAuditService,
        private fb: FormBuilder
    ) {
    }

    ngOnInit() {

        this.companyId = this.activatedRoute.snapshot.params['companyId'];
        this.userId = this.activatedRoute.snapshot.params['userId'];

        this.sharedService.currentUser.subscribe(user => {
            if (user.id) {
                this.user = user;
                this.lendersService.getLenderForContact(user.id).subscribe(
                    lender => {
                        this.lender = lender;
                        this.companyService.get(this.companyId).subscribe(company => {
                            this.company = company;
                            this.headerTitle = {
                                title: user.firstName + " " + user.lastName,
                                breadcrumbs: [
                                    { title: (company.tradingName || company.legalName), url: ['/lenders/company/' + company.id] }
                                ]
                            };
                            this.getModulesForUser(lender.id, company.id, this.userId);
                        })
                    }
                )
            }
        });
        

    }

    getModulesForUser = (lenderId: string, companyId: string, userId: string) => {
        this.lendersService.getAuditModules(lenderId,companyId,userId).subscribe(
            modules => {
                this.selectedModules = modules;
                })
    }

    
}
